import React from 'react';

const PageNotFound = () => <div>404</div>;

export default PageNotFound;
